import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const DottedCircleIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="1.5 3"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default DottedCircleIcon;
